import RightSetLocationModal from './RightSetLocationModal'

export default RightSetLocationModal
